<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3.2 9.2 10 3.5l6.8 5.7M5 10.6v5.1c0 .5.4.9.9.9h8.2c.5 0 .9-.4.9-.9v-5.1"/><path d="M8.2 16.6v-3.7h3.6v3.7"/></svg>
</template>
